import React, { useState } from "react";
import { useSecurity } from '../home/Security';
import {
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import Login from "../home/Login";
import { useEffect } from "react";
import { authProvider } from "../../services/Security";
import { LoggedIn } from "../../App";
import { CaptchaService } from "../../services/V2/keymaster";
import ReCAPTCHA from "react-google-recaptcha";
import { isProd } from "../shared/Functions";
import { ForgotPassword } from "../home/ForgotPassword";
import { ForgotUsername } from "../home/ForgotUsername";

export function UserLogin({ isLoggedIn, setIsLoggedIn, logoutCallback, successToast, errorToast }) {
    const [open, setOpen] = useState<boolean>(false)
    const [forgotPassword, setForgotPassword] = useState<boolean>(false)
    const [forgotUsername, setForgotUsername] = useState<boolean>(false)
    const [user, setUser] = useState<any>()
    const [captchaSucess, setCaptchaSucess] = useState<boolean>(false)
    const { authenticationState, accountInfo } = useSecurity();
    const recaptchaRef: any = React.useRef();

    useEffect(() => {
        if(accountInfo) {
            setUser(accountInfo.account)
        } else if(isLoggedIn === LoggedIn.True) {
            let account = authProvider.getUser()
            setUser({
                name: account.unique_name,
                userName: account.UserName,
                idToken: {
                    ipaddr: account.IpAddress
                }
            })
        }
    }, [accountInfo, isLoggedIn])

    useEffect(() => {
        if(authProvider.getUser()) setIsLoggedIn(LoggedIn.True)
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const logout = () => {
        logoutCallback()
        authProvider.logoutCredentials();
        setIsLoggedIn(LoggedIn.False);
    }

    const preLogIn = async () => {
        if(!captchaSucess){
            const token = await recaptchaRef?.current?.executeAsync();
            CaptchaService.captchaValidate(token)
                .then(x => {
                    if(x.success) {
                        setCaptchaSucess(true)
                        setOpen(true);
                    } else {
                        alert("An error occurred while verifying you are human.")
                    }
                })
        } else {
            setOpen(true);
        }
    }

    if (authenticationState === "Authenticated" || isLoggedIn === LoggedIn.True) {
        return (
            <UncontrolledDropdown>
                <DropdownToggle nav caret>
                    {user?.name}
                </DropdownToggle>
                <DropdownMenu right>
                    <h5 className="dropdown-item-text mb-0">{user?.name}</h5>
                    <p className="dropdown-item-text text-muted mb-0">{user?.userName}</p>
                    <DropdownItem divider />
                    <p className="dropdown-item-text text-muted mb-0">{user?.idToken.ipaddr}</p>
                    <DropdownItem divider />
                    <DropdownItem onClick={logout}>Sign Out</DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    } else {
        return (<>
            {open &&
                <Login setShow={setOpen} setIsLoggedIn={setIsLoggedIn} />
            }
            {forgotPassword &&
                <ForgotPassword setShow={setForgotPassword} success={successToast} fail={errorToast} />
            }
            {forgotUsername &&
                <ForgotUsername setShow={setForgotUsername} success={successToast} fail={errorToast} />
            }
            <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={isProd() ? "6LdysiEhAAAAAPZwsLD0CCf4U8yJvrD6pkuGuTHw" : "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
            />
            <NavItem>
                <NavLink onClick={preLogIn} href='#'>Sign in</NavLink>
                <NavLink onClick={() => setForgotPassword(true)} href='#'>Forgot Password</NavLink>
                <NavLink onClick={() => setForgotUsername(true)} href='#'>Forgot Username</NavLink>
            </NavItem>
        </>);
    }

}

